import React from "react"

import { GlobalView, useGlobalView } from "./store/view"
import { Main } from "./Topics/Main"
import { Recall } from "./Topics/Recall"

const App: React.FC = () => {
    const globalView = useGlobalView()
    return <>{globalView === GlobalView.RECALL ? <Recall /> : <Main />}</>
}

export default App
